export default {"src":"/polygon/_next/static/media/fund_8.fc06a73d.svg","height":80,"width":231};